import { render, staticRenderFns } from "./EmployeeSalarySlip.vue?vue&type=template&id=25df79d6&scoped=true"
import script from "./EmployeeSalarySlip.vue?vue&type=script&lang=js"
export * from "./EmployeeSalarySlip.vue?vue&type=script&lang=js"
import style0 from "./EmployeeSalarySlip.vue?vue&type=style&index=0&id=25df79d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25df79d6",
  null
  
)

export default component.exports